import './ProductsStripe.css';

import Select from 'react-select';
import countries from './countries';
import states from './states';
import styled from '@emotion/styled';

const FormFieldContainer = styled.div`
  display: -ms-flexbox;
  display: flex;
  -ms-flex-align: center;
  align-items: center;
  padding-left: 15px;

  &:first-of-type {
    border-top: none;
  }
`;

const Label = styled.label`
  min-width: 70px;
  padding: 15px 0;
  color: black;
  overflow: hidden;
  font-size: 16px;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const Input = styled.input`
  font-size: 16px;
  width: 100%;
  padding: 15px 15px 15px 8px;
  color: black;
  background-color: transparent;
  animation: 1ms void-animation-out;
  border: none;
  border-bottom: 1px solid gainsboro;
  border-left: 1px solid gainsboro;

  &::placeholder {
    color: silver;
  }

  &:focus {
    outline: none;
    border-bottom: 3px solid #5bc0de;
    padding-bottom: 13px;
  }
`;

const FormField = ({ label, type, name, placeholder }) => {
  return (
    <FormFieldContainer>
      <Label htmlFor={name}>{label}:</Label>
      <Input name={name} type={type} placeholder={placeholder} required />
    </FormFieldContainer>
  );
};

const FormDropdown = ({
  label,
  name,
  placeholder,
  selectedOption,
  onChange,
  type,
  disabled = false,
}) => {
  const options = type === 'countries' ? countries : states;

  const selectStyles = {
    control: (base, state) => ({
      ...base,
      minHeight: 55,
      height: 55,
      backgroundColor: '#fff',
      borderRadius: 5,
      boxShadow: state.isFocused ? '0 0 0 1px #5bc0de' : 'none',
      // remove react-select internal padding inconsistencies
      paddingLeft: 4,
    }),
    valueContainer: (base) => ({
      ...base,
      height: 55,
      padding: '0 8px',
    }),
    input: (base) => ({
      ...base,
      margin: 0,
      padding: 0,
    }),
    singleValue: (base) => ({
      ...base,
      lineHeight: '55px',
      marginLeft: 0,
      fontSize: 16,
      color: '#111827',
    }),
    placeholder: (base) => ({
      ...base,
      lineHeight: '55px',
      marginLeft: 0,
      fontSize: 16,
      color: '#9CA3AF',
    }),
    indicatorsContainer: (base) => ({
      ...base,
      height: 55,
    }),
    dropdownIndicator: (base, state) => ({
      ...base,
      color: state.isFocused ? '#5bc0de' : '#6B7280',
      padding: '0 8px',
      '&:hover': { color: '#5bc0de' },
    }),
    clearIndicator: (base) => ({
      ...base,
      padding: '0 4px',
    }),
    indicatorSeparator: (base) => ({
      ...base,
      display: 'none',
    }),
    menu: (base) => ({
      ...base,
      borderRadius: 6,
      overflow: 'hidden',
    }),
    option: (base, { isFocused, isSelected }) => ({
      ...base,
      backgroundColor: isSelected ? '#5bc0de' : isFocused ? '#E5F6FD' : '#fff',
      color: isSelected ? '#fff' : '#111827',
      cursor: 'pointer',
      fontSize: 15,
      padding: '10px 12px',
      ':active': {
        backgroundColor: isSelected ? '#5bc0de' : '#DFF3FB',
      },
    }),
  };

  return (
    <Select
      className="checkout_dropdown"
      classNamePrefix="billing" // optional, for extra CSS hooks
      value={selectedOption}
      onChange={onChange}
      options={options}
      placeholder={placeholder}
      isDisabled={disabled}
      styles={selectStyles}
      // keep menu anchored/positioned nicely if needed:
      menuPlacement="auto"
      menuPortalTarget={document.body}
    />
  );
};

export { FormField, FormDropdown };
